module.exports = __webpack_public_path__ + "static/media/aciIcon.b0509b5a.svg";